var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ],
      staticClass: "app-main-content",
      attrs: {
        "element-loading-spinner": "none",
        "element-loading-background": "rgba(170,170,170,0)"
      }
    },
    [
      _c(
        "div",
        { staticClass: "tabs-container" },
        [
          _c(
            "el-tabs",
            {
              staticStyle: { width: "100%", height: "100%" },
              attrs: { type: "card" },
              model: {
                value: _vm.activeTabName,
                callback: function($$v) {
                  _vm.activeTabName = $$v
                },
                expression: "activeTabName"
              }
            },
            [
              _c(
                "el-tab-pane",
                {
                  staticStyle: { width: "100%", height: "100%" },
                  attrs: {
                    lazy: true,
                    label: _vm.$t("AirExport.OtherDocuments"),
                    name: "otherDocuments"
                  }
                },
                [
                  _c("batch-upload-file-child", {
                    attrs: {
                      "tab-name": "oDocuments",
                      "tab-title": _vm.$t("AirExport.OtherDocuments"),
                      lob: _vm.lob
                    }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  staticStyle: { width: "100%", height: "100%" },
                  attrs: {
                    lazy: true,
                    label: _vm.$t("AirExport.CustomsDeclarationDocuments"),
                    name: "customsDocuments"
                  }
                },
                [
                  _c("custom-info", {
                    attrs: {
                      "tab-name": "cDocuments",
                      "tab-title": _vm.$t(
                        "AirExport.CustomsDeclarationDocuments"
                      ),
                      lob: _vm.lob
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }